import { DonationModel } from 'autogen/swagger/all';
import React from 'react';
import styled from 'styled-components';
import { SvgSprite } from 'modules/svgSprite';
import {
    ColorNeutralWhite,
    ColorNordicGrey4,
    Spacing4,
    Spacing8,
    Spacing16,
    Spacing24
} from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';
import Image from './image';
import RodeKorsLogo from './assets/svg/icons_rode-kors-dk-horizontal.svg';
import TextContainer from './TextContainer';

const Wrapper = styled.div`
    ${breakpoint.up(sizes.md)} {
        position: relative;
        display: flex;
    }
`;

const Icons = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${Spacing24};

    ${breakpoint.up(sizes.md)} {
        position: absolute;
        top: 0;
        right: 58px;
        padding: ${Spacing4} ${Spacing8};
        background-color: ${ColorNeutralWhite};
    }
`;

const MatasIcon = styled(SvgSprite)`
    width: 60px;
    height: 14px;
    margin-right: ${Spacing16};
`;

const RodeKorsIcon = styled.img`
    width: 50px;
    height: 24px;
`;
export interface IDonationBanner {
    model: DonationModel;
}

export default function DonationBanner({ model }: IDonationBanner): JSX.Element {
    const { isCompleted, completedMessage, options, texts } = model;

    return (
        <Wrapper>
            <Image />
            <TextContainer
                texts={texts}
                options={options}
                completedMessage={completedMessage}
                isCompleted={isCompleted}
            />
            <Icons>
                <MatasIcon sprite="LogoMatas" />
                <RodeKorsIcon src={RodeKorsLogo} alt="Røde Kors ikon" className="icon" />
            </Icons>
        </Wrapper>
    );
}
